import {fromJS, Map} from 'immutable';
import actions from '../actions/eula.actions';
import dieselReducer from 'epic-diesel-common/src/decorators/DieselReducer';
import {Eula as BaseEula} from '@epic-node-services/eula-public-service';

type EulaKeys = 'title' | 'body' | 'key' | 'locale' | 'lastModifiedTimestamp' | 'url' | 'version';

export interface Eula extends Pick<BaseEula, EulaKeys> {
    loading?: boolean;
    accepted?: boolean;
}

export interface EulaState {
    affiliate: Eula;
    conduct: Eula;
}

const Eula = {
    accepted: false,
    title: null,
    body: null,
    key: null,
    locale: null,
    lastModifiedTimestamp: null,
    url: null,
    version: 0,
    loading: false
};

const initialEulaState: EulaState = {
    affiliate: Eula,
    conduct: Eula
};

export const DEFAULT_STATE = fromJS(initialEulaState);

export const eulaReducer = (state: Map<keyof EulaState, Eula> = DEFAULT_STATE, action) => {
    switch (action.type) {
        /**
         * SAC AGREEMENT
         */
        case actions.TYPES.GET_AFFILIATE_AGREEMENT: {
            return state.updateIn(['affiliate', 'loading'], () => true);
        }
        case actions.TYPES.GET_AFFILIATE_AGREEMENT_COMPLETE: {
            return state.merge({
                affiliate: {
                    ...action.payload,
                    loading: false
                }
            });
        }
        case actions.TYPES.GET_AFFILIATE_AGREEMENT_FAILED: {
            return state.updateIn(['affiliate', 'loading'], () => false);
        }

        /**
         * CONDUCT
         */
        case actions.TYPES.GET_CONDUCT_AGREEMENT: {
            return state.updateIn(['conduct', 'loading'], () => true);
        }
        case actions.TYPES.GET_CONDUCT_AGREEMENT_COMPLETE: {
            return state.merge({
                conduct: {
                    ...action.payload,
                    loading: false
                }
            });
        }
        case actions.TYPES.GET_CONDUCT_AGREEMENT_FAILED: {
            return state.updateIn(['conduct', 'loading'], () => false);
        }

        default:
            return state;
    }
};

export default dieselReducer('eula', eulaReducer);
